<script setup>
import AppMenu from '#/general/AppMenu'
import AnalysisTooltipContent from '#/detailsReport/AnalysisTooltipContent'
const props = defineProps(['label', 'showBox', 'boxColor', 'tooltipText', 'hideTooltip'])
</script>

<template lang="pug">
app-menu(position="bottom" content-width="350px" tooltip-mode attach-to-parent)
  template(#parent)
    .infoBtn
      .box(v-if="showBox")
      .label {{label}}:
        .infoCircle.gt-sm
          svg(width='14' height='14' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg')
            circle(cx='11' cy='11' r='9.4' fill='#EB604F' stroke='white' stroke-width='1.2')
            path(d='M9.6 16V9.436H12.312V16H9.6ZM10.956 8.908C10.46 8.908 10.064 8.776 9.768 8.512C9.472 8.248 9.324 7.92 9.324 7.528C9.324 7.136 9.472 6.808 9.768 6.544C10.064 6.28 10.46 6.148 10.956 6.148C11.452 6.148 11.848 6.272 12.144 6.52C12.44 6.768 12.588 7.088 12.588 7.48C12.588 7.896 12.44 8.24 12.144 8.512C11.848 8.776 11.452 8.908 10.956 8.908Z' fill='white')
      slot
  template(#content)
    slot(name="tooltipContent" v-if="$slots.tooltipContent")
    analysis-tooltip-content(
      v-if="tooltipText && !hideTooltip && !$slots.tooltipContent"
      :label="label"
      :tooltip-text="tooltipText"
    )
</template>

<style lang="sass">
.infoBtn
  display: flex
  flex-direction: row
  align-items: center
  .box
    background: v-bind(boxColor)
    border-radius: 4px
    margin-right: 5px
    @media screen and (min-width: 1024px)
      width: 20px
      height: 12px
    @media screen and (max-width: 1023px)
      width: 12px
      height: 9px
  .label
    position: relative
    @media screen and (min-width: 1024px)
      font-weight: 600
      font-size: 16px
      line-height: 130%
      color: #626C85
      margin-right: 5px
    @media screen and (max-width: 1023px)
      font-weight: 600
      font-size: 12px
      line-height: 130%
      color: #626C85
    .infoCircle
      position: absolute
      top: -5px
      right: -20px

</style>
